// https://www.w3.org/TR/2019/NOTE-wai-aria-practices-1.1-20190207/examples/menu-button/js/PopupMenuLinks.js

export default function A11yPopup(node, controller) {
  this.KEYCODE_TAB = 9;
  this.node = node;
  this.controller = controller;
}

A11yPopup.prototype.open = function () {
  (this.node.dataset.classname) ? this.node.classList.add(`${this.node.dataset.classname}--expanded`) : this.node.classList.add("expanded");
  window.dispatchEvent(new Event('A11yPopupOpen'));
  this.manageNavigation();
};

A11yPopup.prototype.close = function () {
  (this.node.dataset.classname) ? this.node.classList.remove(`${this.node.dataset.classname}--expanded`) : this.node.classList.remove("expanded");
};

A11yPopup.prototype.manageNavigation = function() {
  let focusable = this.node.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
  let visibleFocusable = [...focusable].filter(element => element.offsetHeight > 0);
  let lastFocusableElement = visibleFocusable[visibleFocusable.length - 1];

  this.node.addEventListener('keydown', (e) => {
    var isTabPressed = (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB);

    if (!isTabPressed) {
      return;
    }

    if (!e.shiftKey) {
      if (document.activeElement === lastFocusableElement) {
        this.controller.togglePopup();
      }
    }
  });
}
